import React, { useEffect, useState } from "react";

import { EXTERNAL_URLS } from "@constants/api.urls";
import { getContactUsURLs } from "@constants/api.urls";
import { USER_INFO } from "@constants/global.constants";

import IconButton from "@components/IconButton";
import { CollapseImageIcon, ExpandImageIcon } from "@components/SVGs";
import WPButton from "@components/WPButton";
import WPHeaderFooterPage from "@components/WPHeaderFooterPage";
import WPHeading from "@components/WPHeading";
import { WPTypogrpahy } from "@components/WPTypography";

import WPLanguageDropDown from "@common/components/WPLanguageDropDown/WPLanguageDropDown";

import WPEditProfileStepsPage from "@features/WPEditProfileStepsPage/WPEditProfileStepsPage";

import { accessSetupImage, WPAccessDeniedPageConstants } from "./WPAccessDeniedPage.constants";

import "./WPAccessDeniedPage.scss";

const WPAccessDeniedPage = () => {
  const [isHowToEnable, setIsHowToEnable] = useState(false);
  const [termsLanguage, setTermsLanguage] = useState(USER_INFO.cultureName);
  const [isImageExpanded, setIsImageExpanded] = useState(false);

  const translatedAccessDeniedConstants = React.useMemo(
    () => WPAccessDeniedPageConstants(termsLanguage),
    [termsLanguage],
  );

  const handleGoToProfileSettings = () => {
    window.open(EXTERNAL_URLS.myProfile, "_blank");
  };

  const handleHowToEnable = () => {
    setIsHowToEnable(true);
  };

  const handleImageExpandCollapse = () => {
    setIsImageExpanded(prev => !prev);
  };

  // This effect is added to prevent the background page from scrolling when image is enlarged
  useEffect(() => {
    if (isImageExpanded) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isImageExpanded]);

  return (
    <>
      <WPHeaderFooterPage>
        <div className='language-dropdown'>
          <WPLanguageDropDown setTermsLanguage={setTermsLanguage} />
        </div>
        {!isHowToEnable ? (
          <div className='access-card'>
            {!isImageExpanded && (
              <div className='image-container'>
                <img
                  src={accessSetupImage(termsLanguage)[0].src}
                  alt={accessSetupImage(termsLanguage)[0].alt}
                  className='access-image'
                  onClick={handleImageExpandCollapse}
                />
                <IconButton
                  tooltip={translatedAccessDeniedConstants.clickToExpand}
                  onClick={handleImageExpandCollapse}
                  className='expand-collapse-btn'
                  id='expand-btn'
                  name='expand-btn'
                >
                  <ExpandImageIcon />
                </IconButton>
              </div>
            )}
            <WPHeading type='default' color='var(--du-color-black_70)' size='medium'>
              {translatedAccessDeniedConstants.accessNotSetupHeader}
            </WPHeading>
            <div className='access-description-wrapper'>
              <WPTypogrpahy
                align='center'
                text={translatedAccessDeniedConstants.accessNotSetupDescription}
                fontSize={14}
              />
            </div>

            <div className='button-group'>
              <WPButton variant='outlined' customClass='how-to-enable-button' onClick={handleHowToEnable}>
                {translatedAccessDeniedConstants.howToEnable}
              </WPButton>
              <WPButton onClick={handleGoToProfileSettings}>{translatedAccessDeniedConstants.profileSettings}</WPButton>
            </div>

            <a href={getContactUsURLs[termsLanguage]} target='_blank' rel='noopener noreferrer'>
              <WPHeading secondary type='default' color='var(--du-color-black_70)' className='contact-support-button'>
                {translatedAccessDeniedConstants.contactSupport}
              </WPHeading>
            </a>
          </div>
        ) : (
          <WPEditProfileStepsPage isEnable={setIsHowToEnable} termsLanguage={termsLanguage} />
        )}
        {isImageExpanded && (
          <div className='image-expanded-overlay flex-center' onClick={handleImageExpandCollapse}>
            <div className='image-container'>
              <img
                src={accessSetupImage(termsLanguage)[0].src}
                alt={accessSetupImage(termsLanguage)[0].alt}
                className='access-image-expanded'
                onClick={handleImageExpandCollapse}
              />
              <IconButton
                tooltip={translatedAccessDeniedConstants.clickToCompress}
                onClick={handleImageExpandCollapse}
                className='expand-collapse-btn'
                id='collapse-btn'
                name='collapse-btn'
              >
                <CollapseImageIcon />
              </IconButton>
            </div>
          </div>
        )}
      </WPHeaderFooterPage>
    </>
  );
};

export default WPAccessDeniedPage;
